const anup_ffe_defaultStrings = {
	root: 'Root',
	folders: 'Folders',
	files: 'Files',
	loading: 'Loading...',
	empty: 'This folder is empty.',
	loadMore: 'Load more',
	loadError: 'Unable to load this folder.',
	unauthorized: "You've reached restricted content.",
	searchPlaceholder: 'Enter folder name',
	filename: 'Filename',
	modifiedDate: 'Modified Date',
	fileType: 'File type',
	folderType: 'Folder',
	size: 'Size',
	displayingItems: 'Displaying %1 items out of %2',
};

const anup_ffe_defaultConfig = {
	restBase: '',
	selectedFolders: [],
	columns: 5,
	perPage: 30,
	nonce: '',
	strings: anup_ffe_defaultStrings,
};

const anup_ffe_resizeStorageKey = 'wdg-filebird-explorer-sidebar-width';
const anup_ffe_resizeSidebarMin = 240;
const anup_ffe_resizeSidebarMax = 560;
const anup_ffe_resizeSidebarDefault = 320;

const anup_ffe_activeFolderStorageKeyPrefix = 'wdg-filebird-explorer-active-folder';

const anup_ffe_iconSvgMarkupMap = {
	folder: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/></svg>',
	caret: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6z"/></svg>',
	home: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>',
	file: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6 2h8l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm7 7V3.5L18.5 9H13z"/></svg>',
	close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
	search: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10 2a8 8 0 0 1 6.32 12.9l4.39 4.38-1.42 1.42-4.38-4.39A8 8 0 1 1 10 2zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></svg>',
	video: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17 10.5V7c0-1.1-.9-2-2-2H3C1.9 5 1 5.9 1 7v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3.5l6 4v-11l-6 4z"/></svg>',
};

const anup_ffe_stateByRoot = new WeakMap();

function anup_ffe_normalizeFolderIds( value ) {
	if ( Array.isArray( value ) ) {
		return value.map( ( item ) => Number( item ) ).filter( ( item ) => item > 0 );
	}
	if ( typeof value === 'string' && value.indexOf( ',' ) !== -1 ) {
		return value.split( ',' ).map( ( item ) => Number( item ) ).filter( ( item ) => item > 0 );
	}
	const anup_ffe_numericFolderIdValue = Number( value ) || 0;
	return anup_ffe_numericFolderIdValue > 0 ? [ anup_ffe_numericFolderIdValue ] : [];
}

function anup_ffe_getRootFolders( config ) {
	return anup_ffe_normalizeFolderIds( config.selectedFolders );
}

function anup_ffe_getActiveFolderStorageKey( config ) {
	const anup_ffe_roots = anup_ffe_getRootFolders( config );
	const anup_ffe_keySuffix = anup_ffe_roots.length
		? anup_ffe_roots.slice().sort( ( a, b ) => a - b ).join( ',' )
		: 'default';
	return anup_ffe_activeFolderStorageKeyPrefix + '-' + anup_ffe_keySuffix;
}

function anup_ffe_getAncestorIds( folderId, parentMap ) {
	const anup_ffe_ancestors = [];
	let anup_ffe_id = Number( folderId );
	while ( anup_ffe_id > 0 ) {
		const anup_ffe_parent = parentMap.get( anup_ffe_id );
		if ( anup_ffe_parent == null || anup_ffe_parent === 0 ) {
			break;
		}
		anup_ffe_ancestors.push( anup_ffe_parent );
		anup_ffe_id = anup_ffe_parent;
	}
	return anup_ffe_ancestors;
}

function anup_ffe_saveActiveFolder( config, folderId ) {
	if ( folderId == null || folderId === '' ) {
		return;
	}
	try {
		const anup_ffe_key = anup_ffe_getActiveFolderStorageKey( config );
		sessionStorage.setItem( anup_ffe_key, String( folderId ) );
	} catch ( e ) {}
}

function anup_ffe_restoreActiveFolder( config ) {
	try {
		const anup_ffe_key = anup_ffe_getActiveFolderStorageKey( config );
		const anup_ffe_saved = sessionStorage.getItem( anup_ffe_key );
		if ( anup_ffe_saved == null || anup_ffe_saved === '' ) {
			return null;
		}
		const anup_ffe_id = parseInt( anup_ffe_saved, 10 );
		return isNaN( anup_ffe_id ) ? null : anup_ffe_id;
	} catch ( e ) {
		return null;
	}
}

const anup_ffe_urlFolderParam = 'ffe_folder';

function anup_ffe_getFolderIdFromUrl() {
	if ( typeof location === 'undefined' ) {
		return null;
	}
	const anup_ffe_params = new URLSearchParams( location.search );
	const anup_ffe_value = anup_ffe_params.get( anup_ffe_urlFolderParam );
	if ( anup_ffe_value == null || anup_ffe_value === '' ) {
		return null;
	}
	const anup_ffe_id = parseInt( anup_ffe_value, 10 );
	return isNaN( anup_ffe_id ) ? null : anup_ffe_id;
}

function anup_ffe_setFolderIdInUrl( folderId ) {
	if ( typeof location === 'undefined' || typeof history === 'undefined' ) {
		return;
	}
	const anup_ffe_params = new URLSearchParams( location.search );
	if ( folderId > 0 ) {
		anup_ffe_params.set( anup_ffe_urlFolderParam, String( folderId ) );
	} else {
		anup_ffe_params.delete( anup_ffe_urlFolderParam );
	}
	const anup_ffe_query = anup_ffe_params.toString();
	const anup_ffe_newSearch = anup_ffe_query ? '?' + anup_ffe_query : '';
	const anup_ffe_newUrl = location.pathname + anup_ffe_newSearch + location.hash;
	if ( location.pathname + location.search + location.hash !== anup_ffe_newUrl ) {
		history.replaceState( null, '', anup_ffe_newUrl );
	}
}

function anup_ffe_parseConfig( element, overrides ) {
	let anup_ffe_parsedDataConfig = {};
	if ( element && element.dataset && element.dataset.config ) {
		try {
			anup_ffe_parsedDataConfig = JSON.parse( element.dataset.config );
		} catch ( error ) {
			anup_ffe_parsedDataConfig = {};
		}
	}

	const anup_ffe_mergedStringOptions = {
		...anup_ffe_defaultStrings,
		...( anup_ffe_parsedDataConfig.strings || {} ),
		...( overrides && overrides.strings ? overrides.strings : {} ),
	};

	const anup_ffe_mergedConfigObject = {
		...anup_ffe_defaultConfig,
		...anup_ffe_parsedDataConfig,
		...( overrides || {} ),
		strings: anup_ffe_mergedStringOptions,
	};

	anup_ffe_mergedConfigObject.restBase = anup_ffe_mergedConfigObject.restBase || ( window.wpApiSettings ? `${window.wpApiSettings.root}filebird-explorer/v1/` : '' );
	anup_ffe_mergedConfigObject.nonce = anup_ffe_mergedConfigObject.nonce || ( window.wpApiSettings ? window.wpApiSettings.nonce : '' );
	anup_ffe_mergedConfigObject.selectedFolders = anup_ffe_normalizeFolderIds( anup_ffe_mergedConfigObject.selectedFolders );
	anup_ffe_mergedConfigObject.columns = Number( anup_ffe_mergedConfigObject.columns ) || 5;
	anup_ffe_mergedConfigObject.perPage = Number( anup_ffe_mergedConfigObject.perPage ) || 30;

	return anup_ffe_mergedConfigObject;
}

function anup_ffe_getFileExtensionFromUrl( url ) {
	if ( ! url ) {
		return '';
	}
	try {
		const anup_ffe_pathOnly = new URL( url, 'https://example.invalid' ).pathname;
		const anup_ffe_fileName = anup_ffe_pathOnly.split( '/' ).pop() || '';
		const anup_ffe_fileNameParts = anup_ffe_fileName.split( '.' );
		if ( anup_ffe_fileNameParts.length > 1 ) {
			return anup_ffe_fileNameParts.pop().toUpperCase();
		}
	} catch ( e ) {}
	return '';
}

function anup_ffe_formatFileTypeLabel( mimeType, url ) {
	const anup_ffe_mime = ( mimeType || '' ).toLowerCase();
	const anup_ffe_fromMime = {
		'image/jpeg': 'JPEG',
		'image/png': 'PNG',
		'image/gif': 'GIF',
		'image/webp': 'WebP',
		'image/svg+xml': 'SVG',
		'application/pdf': 'PDF',
		'application/msword': 'DOC',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
		'application/vnd.ms-excel': 'XLS',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
		'application/vnd.ms-powerpoint': 'PPT',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
		'text/plain': 'TXT',
		'text/csv': 'CSV',
		'application/zip': 'ZIP',
	};
	if ( anup_ffe_fromMime[ anup_ffe_mime ] ) {
		return anup_ffe_fromMime[ anup_ffe_mime ];
	}
	const anup_ffe_slash = anup_ffe_mime.indexOf( '/' );
	if ( anup_ffe_slash > 0 ) {
		return anup_ffe_mime.slice( anup_ffe_slash + 1 ).toUpperCase();
	}
	return anup_ffe_getFileExtensionFromUrl( url ) || '—';
}

function anup_ffe_buildUrl( base, path, params ) {
	const anup_ffe_normalizedBaseUrl = base.endsWith( '/' ) ? base : `${base}/`;
	const anup_ffe_normalizedPathSegment = path.startsWith( '/' ) ? path.slice( 1 ) : path;
	const anup_ffe_composedUrlObject = new URL( `${anup_ffe_normalizedBaseUrl}${anup_ffe_normalizedPathSegment}` );
	if ( params ) {
		Object.keys( params ).forEach( ( key ) => {
			if ( params[ key ] !== undefined && params[ key ] !== null && params[ key ] !== '' ) {
				anup_ffe_composedUrlObject.searchParams.set( key, params[ key ] );
			}
		} );
	}
	return anup_ffe_composedUrlObject.toString();
}

function anup_ffe_refreshNonce( config ) {
	if ( ! config || ! config.restNonceUrl ) {
		return Promise.resolve();
	}
	return fetch( config.restNonceUrl, {
		method: 'GET',
		credentials: 'same-origin',
		cache: 'no-store',
	} )
		.then( ( response ) => ( response.ok ? response.text() : '' ) )
		.then( ( nonce ) => {
			const anup_ffe_trimmedNonce = ( nonce || '' ).trim();
			if ( /^[a-f0-9]{8,64}$/i.test( anup_ffe_trimmedNonce ) ) {
				config.nonce = anup_ffe_trimmedNonce;
			}
		} )
		.catch( () => {} );
}

function anup_ffe_fetchJson( config, path, params ) {
	const anup_ffe_requestHeadersObject = {};
	if ( config && config.nonce ) {
		anup_ffe_requestHeadersObject[ 'X-WP-Nonce' ] = config.nonce;
	}
	return fetch( anup_ffe_buildUrl( config.restBase, path, params ), {
		method: 'GET',
		credentials: 'same-origin',
		headers: anup_ffe_requestHeadersObject,
	} ).then( ( response ) => response.json() );
}

function anup_ffe_createLoadingSpinnerAndText( loadingText ) {
	const anup_ffe_spinner = document.createElement( 'span' );
	anup_ffe_spinner.className = 'wdg-filebird-explorer__load-more-spinner';
	anup_ffe_spinner.setAttribute( 'aria-hidden', 'true' );
	const anup_ffe_textSpan = document.createElement( 'span' );
	anup_ffe_textSpan.textContent = loadingText;
	return { spinner: anup_ffe_spinner, textSpan: anup_ffe_textSpan };
}

function anup_ffe_ensureShell( root ) {
	let anup_ffe_sidebarContainer = root.querySelector( '.wdg-filebird-explorer__sidebar' );
	let anup_ffe_treeContainerElement = root.querySelector( '.wdg-filebird-explorer__tree' );
	let anup_ffe_breadcrumbContainer = root.querySelector( '.wdg-filebird-explorer__breadcrumb' );
	let anup_ffe_contentContainer = root.querySelector( '.wdg-filebird-explorer__content' );
	let anup_ffe_searchInputElement = root.querySelector( '.wdg-filebird-explorer__search-input' );

	if ( anup_ffe_sidebarContainer && anup_ffe_treeContainerElement && anup_ffe_breadcrumbContainer && anup_ffe_contentContainer && anup_ffe_searchInputElement ) {
		const anup_ffe_shellContainer = anup_ffe_contentContainer.closest( '.wdg-filebird-explorer__shell' );
		return {
			shell: anup_ffe_shellContainer || undefined,
			sidebar: anup_ffe_sidebarContainer,
			tree: anup_ffe_treeContainerElement,
			breadcrumb: anup_ffe_breadcrumbContainer,
			content: anup_ffe_contentContainer,
			searchInput: anup_ffe_searchInputElement,
		};
	}

	root.innerHTML = '';

	const anup_ffe_shellContainer = document.createElement( 'div' );
	anup_ffe_shellContainer.className = 'wdg-filebird-explorer__shell';

	anup_ffe_sidebarContainer = document.createElement( 'div' );
	anup_ffe_sidebarContainer.className = 'wdg-filebird-explorer__sidebar';

	// Search field (hidden from frontend; uncomment block below to show again)
	// const anup_ffe_searchWrapElement = document.createElement( 'div' );
	// anup_ffe_searchWrapElement.className = 'wdg-filebird-explorer__search';
	// const anup_ffe_searchFieldElement = document.createElement( 'div' );
	// anup_ffe_searchFieldElement.className = 'wdg-filebird-explorer__search-field';
	// const anup_ffe_searchIconElement = document.createElement( 'span' );
	// anup_ffe_searchIconElement.className = 'wdg-filebird-explorer__search-icon';
	// anup_ffe_searchIconElement.innerHTML = anup_ffe_iconSvgMarkupMap.search;
	// anup_ffe_searchFieldElement.appendChild( anup_ffe_searchIconElement );
	// anup_ffe_searchInputElement = document.createElement( 'input' );
	// anup_ffe_searchInputElement.type = 'search';
	// anup_ffe_searchInputElement.className = 'wdg-filebird-explorer__search-input';
	// anup_ffe_searchFieldElement.appendChild( anup_ffe_searchInputElement );
	// anup_ffe_searchWrapElement.appendChild( anup_ffe_searchFieldElement );
	anup_ffe_searchInputElement = document.createElement( 'input' ); // placeholder when search UI is commented out

	anup_ffe_treeContainerElement = document.createElement( 'div' );
	anup_ffe_treeContainerElement.className = 'wdg-filebird-explorer__tree';

	// anup_ffe_sidebarContainer.appendChild( anup_ffe_searchWrapElement );
	anup_ffe_sidebarContainer.appendChild( anup_ffe_treeContainerElement );

	const anup_ffe_mainContainerElement = document.createElement( 'div' );
	anup_ffe_mainContainerElement.className = 'wdg-filebird-explorer__main';

	anup_ffe_breadcrumbContainer = document.createElement( 'div' );
	anup_ffe_breadcrumbContainer.className = 'wdg-filebird-explorer__breadcrumb';

	anup_ffe_contentContainer = document.createElement( 'div' );
	anup_ffe_contentContainer.className = 'wdg-filebird-explorer__content';

	anup_ffe_mainContainerElement.appendChild( anup_ffe_breadcrumbContainer );
	anup_ffe_mainContainerElement.appendChild( anup_ffe_contentContainer );

	const anup_ffe_resizeHandle = document.createElement( 'div' );
	anup_ffe_resizeHandle.className = 'wdg-filebird-explorer__resize-handle';
	anup_ffe_resizeHandle.setAttribute( 'aria-label', 'Resize sidebar' );
	anup_ffe_resizeHandle.setAttribute( 'role', 'separator' );

	anup_ffe_shellContainer.appendChild( anup_ffe_sidebarContainer );
	anup_ffe_shellContainer.appendChild( anup_ffe_resizeHandle );
	anup_ffe_shellContainer.appendChild( anup_ffe_mainContainerElement );
	root.appendChild( anup_ffe_shellContainer );

	return {
		shell: anup_ffe_shellContainer,
		sidebar: anup_ffe_sidebarContainer,
		tree: anup_ffe_treeContainerElement,
		breadcrumb: anup_ffe_breadcrumbContainer,
		content: anup_ffe_contentContainer,
		searchInput: anup_ffe_searchInputElement,
		resizeHandle: anup_ffe_resizeHandle,
	};
}

function anup_ffe_buildMaps( tree, map, parentMap ) {
	if ( ! Array.isArray( tree ) ) {
		return;
	}

	tree.forEach( ( node ) => {
		if ( node && typeof node.id !== 'undefined' ) {
			map.set( Number( node.id ), node );
			parentMap.set( Number( node.id ), Number( node.parent || 0 ) );
		}
		if ( node && node.children ) {
			anup_ffe_buildMaps( node.children, map, parentMap );
		}
	} );
}

function anup_ffe_filterRootIdsToTopLevel( rootIds, parentMap ) {
	const anup_ffe_uniqueRootIdsList = Array.from( new Set( rootIds.map( ( item ) => Number( item ) ).filter( ( item ) => item > 0 ) ) );
	if ( anup_ffe_uniqueRootIdsList.length === 0 ) {
		return [];
	}

	const anup_ffe_rootIdLookupMap = new Set( anup_ffe_uniqueRootIdsList );
	const anup_ffe_topLevelRootIdsList = [];

	anup_ffe_uniqueRootIdsList.forEach( ( rootId ) => {
		let anup_ffe_parentIdWalkerValue = parentMap.get( rootId ) || 0;
		let anup_ffe_hasAncestorInRootSetFlag = false;

		while ( anup_ffe_parentIdWalkerValue ) {
			if ( anup_ffe_rootIdLookupMap.has( anup_ffe_parentIdWalkerValue ) ) {
				anup_ffe_hasAncestorInRootSetFlag = true;
				break;
			}
			anup_ffe_parentIdWalkerValue = parentMap.get( anup_ffe_parentIdWalkerValue ) || 0;
		}

		if ( ! anup_ffe_hasAncestorInRootSetFlag ) {
			anup_ffe_topLevelRootIdsList.push( rootId );
		}
	} );

	return anup_ffe_topLevelRootIdsList;
}

function anup_ffe_buildBreadcrumbTrail( state, folderId ) {
	const anup_ffe_breadcrumbTrailNodes = [];
	let anup_ffe_currentTrailNode = state.nodeMap.get( folderId );
	while ( anup_ffe_currentTrailNode ) {
		anup_ffe_breadcrumbTrailNodes.unshift( anup_ffe_currentTrailNode );
		const anup_ffe_parentFolderIdValue = state.parentMap.get( Number( anup_ffe_currentTrailNode.id ) );
		anup_ffe_currentTrailNode = anup_ffe_parentFolderIdValue ? state.nodeMap.get( anup_ffe_parentFolderIdValue ) : null;
	}
	return anup_ffe_breadcrumbTrailNodes;
}

function anup_ffe_attachKeyboardActivateHandler( element, handler ) {
	const anup_ffe_keyboardActivationHandlerForItem = ( event ) => {
		if ( event.key === 'Enter' || event.key === ' ' ) {
			event.preventDefault();
			handler();
		}
	};
	element.addEventListener( 'keydown', anup_ffe_keyboardActivationHandlerForItem );
}

function anup_ffe_renderBreadcrumb( state ) {
	const { breadcrumb: anup_ffe_breadcrumbContainerElement } = state.shell;
	const { strings: anup_ffe_stringLabels } = state.config;

	const anup_ffe_breadcrumbTrailNodes = anup_ffe_buildBreadcrumbTrail( state, state.activeFolder );
	anup_ffe_breadcrumbContainerElement.innerHTML = '';

	const anup_ffe_breadcrumbListElement = document.createElement( 'div' );
	anup_ffe_breadcrumbListElement.className = 'wdg-filebird-explorer__breadcrumb-list';

	const anup_ffe_breadcrumbHomeButton = document.createElement( 'button' );
	anup_ffe_breadcrumbHomeButton.type = 'button';
	anup_ffe_breadcrumbHomeButton.className = 'wdg-filebird-explorer__breadcrumb-home';
	anup_ffe_breadcrumbHomeButton.innerHTML = anup_ffe_iconSvgMarkupMap.home;
	anup_ffe_breadcrumbHomeButton.addEventListener( 'click', () => {
		anup_ffe_loadFolder( state, 0 );
	} );
	anup_ffe_breadcrumbListElement.appendChild( anup_ffe_breadcrumbHomeButton );

	if ( anup_ffe_breadcrumbTrailNodes.length ) {
		const anup_ffe_breadcrumbSeparator = document.createElement( 'span' );
		anup_ffe_breadcrumbSeparator.textContent = '/';
		anup_ffe_breadcrumbSeparator.className = 'wdg-filebird-explorer__breadcrumb-sep';
		anup_ffe_breadcrumbListElement.appendChild( anup_ffe_breadcrumbSeparator );
	}

	anup_ffe_breadcrumbTrailNodes.forEach( ( node, index ) => {
		const anup_ffe_breadcrumbLinkButton = document.createElement( 'button' );
		anup_ffe_breadcrumbLinkButton.type = 'button';
		anup_ffe_breadcrumbLinkButton.className = 'wdg-filebird-explorer__breadcrumb-link';
		anup_ffe_breadcrumbLinkButton.textContent = node.text || node.name || anup_ffe_stringLabels.root;
		anup_ffe_breadcrumbLinkButton.addEventListener( 'click', () => {
			anup_ffe_loadFolder( state, Number( node.id ) );
		} );
		anup_ffe_breadcrumbListElement.appendChild( anup_ffe_breadcrumbLinkButton );

		if ( index < anup_ffe_breadcrumbTrailNodes.length - 1 ) {
			const anup_ffe_breadcrumbSeparator = document.createElement( 'span' );
			anup_ffe_breadcrumbSeparator.textContent = '/';
			anup_ffe_breadcrumbSeparator.className = 'wdg-filebird-explorer__breadcrumb-sep';
			anup_ffe_breadcrumbListElement.appendChild( anup_ffe_breadcrumbSeparator );
		}
	} );

	anup_ffe_breadcrumbContainerElement.appendChild( anup_ffe_breadcrumbListElement );
}

function anup_ffe_renderTree( state ) {
	const { tree: anup_ffe_treeContainerElement } = state.shell;
	const { expanded: anup_ffe_expandedNodeSet } = state;
	const anup_ffe_limitTreeToRoots = Boolean( state.searchValue );

	anup_ffe_treeContainerElement.innerHTML = '';

	const anup_ffe_treeListElement = document.createElement( 'ul' );
	anup_ffe_treeListElement.className = 'wdg-filebird-explorer__tree-list';

	const anup_ffe_buildTreeNodeElement = ( node, depth ) => {
		const anup_ffe_treeListItem = document.createElement( 'li' );
		anup_ffe_treeListItem.className = 'wdg-filebird-explorer__tree-node';

		const anup_ffe_treeRowButton = document.createElement( 'button' );
		anup_ffe_treeRowButton.type = 'button';
		anup_ffe_treeRowButton.className = 'wdg-filebird-explorer__tree-row';
		anup_ffe_treeRowButton.style.paddingLeft = `${Math.max( depth * 16, 0 )}px`;

		if ( Number( node.id ) === state.activeFolder ) {
			anup_ffe_treeRowButton.className += ' is-active';
		}

		const anup_ffe_nodeHasChildren = ! anup_ffe_limitTreeToRoots && node.children && node.children.length > 0;
		if ( anup_ffe_nodeHasChildren ) {
			const anup_ffe_treeToggleIcon = document.createElement( 'span' );
			anup_ffe_treeToggleIcon.className = 'wdg-filebird-explorer__tree-toggle';
			anup_ffe_treeToggleIcon.innerHTML = anup_ffe_iconSvgMarkupMap.caret;
			anup_ffe_treeToggleIcon.style.transform = anup_ffe_expandedNodeSet.has( Number( node.id ) ) ? 'rotate(0deg)' : 'rotate(-90deg)';
			anup_ffe_treeToggleIcon.addEventListener( 'click', ( event ) => {
				event.stopPropagation();
				if ( anup_ffe_expandedNodeSet.has( Number( node.id ) ) ) {
					anup_ffe_expandedNodeSet.delete( Number( node.id ) );
				} else {
					anup_ffe_expandedNodeSet.add( Number( node.id ) );
				}
				anup_ffe_renderTree( state );
			} );
			anup_ffe_treeRowButton.appendChild( anup_ffe_treeToggleIcon );
		} else {
			const anup_ffe_treeSpacerIcon = document.createElement( 'span' );
			anup_ffe_treeSpacerIcon.className = 'wdg-filebird-explorer__tree-spacer';
			anup_ffe_treeRowButton.appendChild( anup_ffe_treeSpacerIcon );
		}

		const anup_ffe_treeLabelWrapper = document.createElement( 'span' );
		anup_ffe_treeLabelWrapper.className = 'wdg-filebird-explorer__tree-label';
		anup_ffe_treeLabelWrapper.innerHTML = anup_ffe_iconSvgMarkupMap.folder;

		const anup_ffe_treeNodeNameText = document.createElement( 'span' );
		anup_ffe_treeNodeNameText.className = 'wdg-filebird-explorer__tree-name';
		const anup_ffe_folderDisplayName = node.text || node.name || '';
		anup_ffe_treeNodeNameText.textContent = anup_ffe_folderDisplayName;
		if ( anup_ffe_folderDisplayName ) {
			anup_ffe_treeNodeNameText.setAttribute( 'title', anup_ffe_folderDisplayName );
		}
		anup_ffe_treeLabelWrapper.appendChild( anup_ffe_treeNodeNameText );
		anup_ffe_treeRowButton.appendChild( anup_ffe_treeLabelWrapper );

		const anup_ffe_treeCountValue = typeof node[ 'data-count' ] !== 'undefined' ? node[ 'data-count' ] : node.count;
		if ( typeof anup_ffe_treeCountValue !== 'undefined' ) {
			const anup_ffe_treeCountBadge = document.createElement( 'span' );
			anup_ffe_treeCountBadge.className = 'wdg-filebird-explorer__tree-count';
			anup_ffe_treeCountBadge.textContent = anup_ffe_treeCountValue;
			anup_ffe_treeRowButton.appendChild( anup_ffe_treeCountBadge );
		}

		anup_ffe_treeRowButton.addEventListener( 'click', () => {
			anup_ffe_loadFolder( state, Number( node.id ) );
		} );

		anup_ffe_treeListItem.appendChild( anup_ffe_treeRowButton );

		if ( anup_ffe_nodeHasChildren && anup_ffe_expandedNodeSet.has( Number( node.id ) ) ) {
			const anup_ffe_childListElement = document.createElement( 'ul' );
			anup_ffe_childListElement.className = 'wdg-filebird-explorer__tree-list';
			node.children.forEach( ( child ) => {
				anup_ffe_childListElement.appendChild( anup_ffe_buildTreeNodeElement( child, depth + 1 ) );
			} );
			anup_ffe_treeListItem.appendChild( anup_ffe_childListElement );
		}

		return anup_ffe_treeListItem;
	};

	const anup_ffe_selectedRootFolderIdsList = anup_ffe_getRootFolders( state.config );
	const anup_ffe_topLevelRootFolderIdsList = anup_ffe_limitTreeToRoots
		? anup_ffe_selectedRootFolderIdsList
		: anup_ffe_filterRootIdsToTopLevel( anup_ffe_selectedRootFolderIdsList, state.parentMap );
	const anup_ffe_treeRootDisplayNodes = anup_ffe_selectedRootFolderIdsList.length
		? ( anup_ffe_limitTreeToRoots
			? state.treeData
			: anup_ffe_topLevelRootFolderIdsList.map( ( rootId ) => state.nodeMap.get( rootId ) ).filter( Boolean ) )
		: state.treeData.filter( ( node ) => ! node.parent || Number( node.parent ) === 0 );

	anup_ffe_treeRootDisplayNodes.forEach( ( node ) => {
		anup_ffe_treeListElement.appendChild( anup_ffe_buildTreeNodeElement( node, 0 ) );
	} );

	anup_ffe_treeContainerElement.appendChild( anup_ffe_treeListElement );
}

function anup_ffe_ensureModal( state ) {
	if ( state.modal && state.modal.overlay && document.contains( state.modal.overlay ) ) {
		console.log( '[FFE media] ensureModal: reusing existing modal' );
		return state.modal;
	}
	if ( state.modal && state.modal.overlay && ! document.contains( state.modal.overlay ) ) {
		console.log( '[FFE media] ensureModal: existing modal detached (e.g. editor re-render), recreating' );
		state.modal = null;
	}
	console.log( '[FFE media] ensureModal: creating new modal' );

	const anup_ffe_modalOverlayElement = document.createElement( 'div' );
	anup_ffe_modalOverlayElement.className = 'wdg-filebird-explorer__modal';
	anup_ffe_modalOverlayElement.setAttribute( 'aria-hidden', 'true' );

	const anup_ffe_modalBackdropElement = document.createElement( 'div' );
	anup_ffe_modalBackdropElement.className = 'wdg-filebird-explorer__modal-backdrop';

	const anup_ffe_modalDialogElement = document.createElement( 'div' );
	anup_ffe_modalDialogElement.className = 'wdg-filebird-explorer__modal-dialog';
	anup_ffe_modalDialogElement.setAttribute( 'role', 'dialog' );

	const anup_ffe_modalCloseButton = document.createElement( 'span' );
	anup_ffe_modalCloseButton.className = 'wdg-filebird-explorer__modal-close';
	anup_ffe_modalCloseButton.innerHTML = anup_ffe_iconSvgMarkupMap.close;

	const anup_ffe_modalBodyElement = document.createElement( 'div' );
	anup_ffe_modalBodyElement.className = 'wdg-filebird-explorer__modal-body';

	anup_ffe_modalDialogElement.appendChild( anup_ffe_modalCloseButton );
	anup_ffe_modalDialogElement.appendChild( anup_ffe_modalBodyElement );
	anup_ffe_modalOverlayElement.appendChild( anup_ffe_modalBackdropElement );
	anup_ffe_modalOverlayElement.appendChild( anup_ffe_modalDialogElement );
	const anup_ffe_shellRoot = state.shell.shell || state.shell.content.closest( '.wdg-filebird-explorer__shell' );
	console.log( '[FFE media] ensureModal: appending to', anup_ffe_shellRoot ? 'shell' : 'content fallback', { hasShellRef: !! state.shell.shell } );
	( anup_ffe_shellRoot || state.shell.content ).appendChild( anup_ffe_modalOverlayElement );

	const anup_ffe_closeModalHandler = () => {
		console.log( '[FFE media] modal closed' );
		anup_ffe_modalOverlayElement.classList.remove( 'is-open' );
		anup_ffe_modalOverlayElement.setAttribute( 'aria-hidden', 'true' );
		anup_ffe_modalBodyElement.innerHTML = '';
	};

	anup_ffe_modalCloseButton.addEventListener( 'click', anup_ffe_closeModalHandler );
	anup_ffe_modalBackdropElement.addEventListener( 'click', anup_ffe_closeModalHandler );
	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && anup_ffe_modalOverlayElement.classList.contains( 'is-open' ) ) {
			anup_ffe_closeModalHandler();
		}
	} );

	state.modal = { overlay: anup_ffe_modalOverlayElement, body: anup_ffe_modalBodyElement, open: ( content ) => {
		console.log( '[FFE media] modal.open()', { bodyInDom: document.contains( anup_ffe_modalBodyElement ), overlayInDom: document.contains( anup_ffe_modalOverlayElement ) } );
		anup_ffe_modalBodyElement.innerHTML = '';
		anup_ffe_modalBodyElement.appendChild( content );
		anup_ffe_modalOverlayElement.classList.add( 'is-open' );
		anup_ffe_modalOverlayElement.setAttribute( 'aria-hidden', 'false' );
	} };

	return state.modal;
}

function anup_ffe_setupResize( root ) {
	const anup_ffe_shell = root.querySelector && root.querySelector( '.wdg-filebird-explorer__shell' );
	if ( ! anup_ffe_shell ) {
		return;
	}
	let anup_ffe_handle = root.querySelector && root.querySelector( '.wdg-filebird-explorer__resize-handle' );
	const anup_ffe_sidebar = root.querySelector && root.querySelector( '.wdg-filebird-explorer__sidebar' );
	if ( ! anup_ffe_handle && anup_ffe_sidebar && anup_ffe_sidebar.nextSibling ) {
		anup_ffe_handle = document.createElement( 'div' );
		anup_ffe_handle.className = 'wdg-filebird-explorer__resize-handle';
		anup_ffe_handle.setAttribute( 'aria-label', 'Resize sidebar' );
		anup_ffe_handle.setAttribute( 'role', 'separator' );
		anup_ffe_shell.insertBefore( anup_ffe_handle, anup_ffe_sidebar.nextSibling );
	}
	if ( ! anup_ffe_handle ) {
		return;
	}
	const anup_ffe_applyWidth = ( widthPx ) => {
		const anup_ffe_clamped = Math.min( anup_ffe_resizeSidebarMax, Math.max( anup_ffe_resizeSidebarMin, widthPx ) );
		anup_ffe_shell.style.setProperty( '--filebird-sidebar-width', anup_ffe_clamped + 'px' );
		try {
			localStorage.setItem( anup_ffe_resizeStorageKey, String( anup_ffe_clamped ) );
		} catch ( e ) {}
	};
	const anup_ffe_saved = parseInt( localStorage.getItem( anup_ffe_resizeStorageKey ), 10 );
	if ( ! isNaN( anup_ffe_saved ) && anup_ffe_saved >= anup_ffe_resizeSidebarMin && anup_ffe_saved <= anup_ffe_resizeSidebarMax ) {
		anup_ffe_applyWidth( anup_ffe_saved );
	} else {
		anup_ffe_applyWidth( anup_ffe_resizeSidebarDefault );
	}
	if ( anup_ffe_handle.dataset.resizeInitialized ) {
		return;
	}
	anup_ffe_handle.dataset.resizeInitialized = '1';

	const anup_ffe_startResize = ( clientX ) => {
		const anup_ffe_startWidth = parseInt( anup_ffe_shell.style.getPropertyValue( '--filebird-sidebar-width' ), 10 ) || anup_ffe_resizeSidebarDefault;
		const anup_ffe_onMove = ( moveX ) => {
			const anup_ffe_delta = moveX - anup_ffe_startX;
			anup_ffe_applyWidth( anup_ffe_startWidth + anup_ffe_delta );
		};
		let anup_ffe_startX = clientX;
		const anup_ffe_onMouseMove = ( moveEvent ) => {
			anup_ffe_onMove( moveEvent.clientX );
		};
		const anup_ffe_onMouseUp = () => {
			document.removeEventListener( 'mousemove', anup_ffe_onMouseMove );
			document.removeEventListener( 'mouseup', anup_ffe_onMouseUp );
			document.body.style.cursor = '';
			document.body.style.userSelect = '';
		};
		document.body.style.cursor = 'col-resize';
		document.body.style.userSelect = 'none';
		document.addEventListener( 'mousemove', anup_ffe_onMouseMove );
		document.addEventListener( 'mouseup', anup_ffe_onMouseUp );
	};

	const anup_ffe_onTouchMove = ( touchEvent ) => {
		if ( touchEvent.cancelable && touchEvent.touches.length === 1 ) {
			touchEvent.preventDefault();
			anup_ffe_touchMoveHandler( touchEvent.touches[ 0 ].clientX );
		}
	};
	let anup_ffe_touchMoveHandler;
	const anup_ffe_onTouchEnd = () => {
		document.removeEventListener( 'touchmove', anup_ffe_onTouchMove, { passive: false } );
		document.removeEventListener( 'touchend', anup_ffe_onTouchEnd );
		document.removeEventListener( 'touchcancel', anup_ffe_onTouchEnd );
	};

	anup_ffe_handle.addEventListener( 'mousedown', ( e ) => {
		if ( e.button !== 0 ) {
			return;
		}
		e.preventDefault();
		anup_ffe_startResize( e.clientX );
	} );

	anup_ffe_handle.addEventListener( 'touchstart', ( e ) => {
		if ( e.touches.length !== 1 ) {
			return;
		}
		const anup_ffe_startWidth = parseInt( anup_ffe_shell.style.getPropertyValue( '--filebird-sidebar-width' ), 10 ) || anup_ffe_resizeSidebarDefault;
		const anup_ffe_startX = e.touches[ 0 ].clientX;
		anup_ffe_touchMoveHandler = ( moveX ) => {
			const anup_ffe_delta = moveX - anup_ffe_startX;
			anup_ffe_applyWidth( anup_ffe_startWidth + anup_ffe_delta );
		};
		document.addEventListener( 'touchmove', anup_ffe_onTouchMove, { passive: false } );
		document.addEventListener( 'touchend', anup_ffe_onTouchEnd );
		document.addEventListener( 'touchcancel', anup_ffe_onTouchEnd );
	}, { passive: true } );
}

function anup_ffe_renderContent( state, data, append ) {
	const { content: anup_ffe_contentContainerElement } = state.shell;
	const { strings: anup_ffe_stringLabels } = state.config;

	if ( ! append ) {
		anup_ffe_contentContainerElement.innerHTML = '';
		state.contentTableBody = null;
	}

	const anup_ffe_subfolderItems = Array.isArray( data.subfolders ) ? data.subfolders : [];
	const anup_ffe_attachmentItems = Array.isArray( data.attachments ) ? data.attachments : [];
	const anup_ffe_isUnauthorizedResponseFlag = Boolean( data && data.unauthorized );

	if ( ! append && anup_ffe_isUnauthorizedResponseFlag ) {
		const anup_ffe_unauthorizedMessageElement = document.createElement( 'div' );
		anup_ffe_unauthorizedMessageElement.className = 'wdg-filebird-explorer__unauthorized';
		const anup_ffe_unauthorizedText = anup_ffe_stringLabels.unauthorized || "You've reached restricted content.";
		anup_ffe_unauthorizedMessageElement.innerHTML = anup_ffe_unauthorizedText.replace( ' member ', ' member<br>' );
		anup_ffe_contentContainerElement.appendChild( anup_ffe_unauthorizedMessageElement );
		return;
	}

	if ( ! append ) {
		const anup_ffe_tableWrap = document.createElement( 'div' );
		anup_ffe_tableWrap.className = 'wdg-filebird-explorer__content-table-wrap';

		const anup_ffe_table = document.createElement( 'table' );
		anup_ffe_table.className = 'wdg-filebird-explorer__content-table';

		const anup_ffe_thead = document.createElement( 'thead' );
		anup_ffe_thead.className = 'wdg-filebird-explorer__content-table-header';
		const anup_ffe_headerRow = document.createElement( 'tr' );
		const anup_ffe_thFilename = document.createElement( 'th' );
		anup_ffe_thFilename.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--filename';
		anup_ffe_thFilename.textContent = anup_ffe_stringLabels.filename || 'Filename';
		const anup_ffe_thDate = document.createElement( 'th' );
		anup_ffe_thDate.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--date';
		anup_ffe_thDate.textContent = anup_ffe_stringLabels.modifiedDate || 'Modified Date';
		const anup_ffe_thType = document.createElement( 'th' );
		anup_ffe_thType.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--type';
		anup_ffe_thType.textContent = anup_ffe_stringLabels.fileType || 'File type';
		const anup_ffe_thSize = document.createElement( 'th' );
		anup_ffe_thSize.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--size';
		anup_ffe_thSize.textContent = anup_ffe_stringLabels.size || 'Size';
		anup_ffe_headerRow.appendChild( anup_ffe_thFilename );
		anup_ffe_headerRow.appendChild( anup_ffe_thDate );
		anup_ffe_headerRow.appendChild( anup_ffe_thType );
		anup_ffe_headerRow.appendChild( anup_ffe_thSize );
		anup_ffe_thead.appendChild( anup_ffe_headerRow );
		anup_ffe_table.appendChild( anup_ffe_thead );

		const anup_ffe_tbody = document.createElement( 'tbody' );
		anup_ffe_tbody.className = 'wdg-filebird-explorer__content-table-body';
		anup_ffe_table.appendChild( anup_ffe_tbody );

		anup_ffe_tableWrap.appendChild( anup_ffe_table );
		anup_ffe_contentContainerElement.appendChild( anup_ffe_tableWrap );
		state.contentTableBody = anup_ffe_tbody;
	}

	const anup_ffe_tbody = state.contentTableBody;
	if ( ! anup_ffe_tbody ) {
		anup_ffe_renderLoadMore( state, data.hasMore );
		return;
	}

	function anup_ffe_createMediaClickHandler( attachment ) {
		const anup_ffe_isImageAttachment = Boolean( attachment.isImage );
		const anup_ffe_attachmentMimeType = attachment.mimeType || '';
		const anup_ffe_isVideoAttachment = anup_ffe_attachmentMimeType.startsWith( 'video/' );
		return () => {
			const anup_ffe_mediaUrl = attachment.fullUrl || attachment.url;
			if ( ! anup_ffe_isImageAttachment && ! anup_ffe_isVideoAttachment ) {
				window.open( attachment.url, '_blank', 'noopener' );
				return;
			}
			const anup_ffe_modalController = anup_ffe_ensureModal( state );
			const anup_ffe_modalLoaderEl = document.createElement( 'div' );
			anup_ffe_modalLoaderEl.className = 'wdg-filebird-explorer__modal-loading';
			anup_ffe_modalLoaderEl.setAttribute( 'aria-busy', 'true' );
			const anup_ffe_modalLoadingParts = anup_ffe_createLoadingSpinnerAndText( state.config.strings.loading );
			anup_ffe_modalLoaderEl.appendChild( anup_ffe_modalLoadingParts.spinner );
			anup_ffe_modalLoaderEl.appendChild( anup_ffe_modalLoadingParts.textSpan );
			anup_ffe_modalController.open( anup_ffe_modalLoaderEl );

			if ( anup_ffe_isVideoAttachment ) {
				const anup_ffe_videoElementNode = document.createElement( 'video' );
				anup_ffe_videoElementNode.controls = true;
				anup_ffe_videoElementNode.className = 'wdg-filebird-explorer__modal-media';
				anup_ffe_videoElementNode.src = anup_ffe_mediaUrl;
				anup_ffe_videoElementNode.addEventListener( 'canplay', () => {
					anup_ffe_modalController.body.innerHTML = '';
					anup_ffe_modalController.body.appendChild( anup_ffe_videoElementNode );
				}, { once: true } );
				anup_ffe_videoElementNode.addEventListener( 'error', () => {
					anup_ffe_modalController.body.innerHTML = '';
					anup_ffe_modalController.body.appendChild( anup_ffe_videoElementNode );
				}, { once: true } );
				return;
			}
			const anup_ffe_imageElementNode = document.createElement( 'img' );
			anup_ffe_imageElementNode.src = anup_ffe_mediaUrl;
			anup_ffe_imageElementNode.alt = attachment.alt || attachment.title || '';
			anup_ffe_imageElementNode.className = 'wdg-filebird-explorer__modal-media';
			anup_ffe_imageElementNode.onload = () => {
				anup_ffe_modalController.body.innerHTML = '';
				anup_ffe_modalController.body.appendChild( anup_ffe_imageElementNode );
			};
			anup_ffe_imageElementNode.onerror = () => {
				anup_ffe_modalController.body.innerHTML = '';
				anup_ffe_modalController.body.appendChild( anup_ffe_imageElementNode );
			};
		};
	}

	if ( ! append ) {
		anup_ffe_subfolderItems.forEach( ( folder ) => {
			const anup_ffe_row = document.createElement( 'tr' );
			anup_ffe_row.className = 'wdg-filebird-explorer__content-table-row wdg-filebird-explorer__content-table-row--folder';

			const anup_ffe_filenameCell = document.createElement( 'td' );
			anup_ffe_filenameCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--filename';
			const anup_ffe_folderIconSpan = document.createElement( 'span' );
			anup_ffe_folderIconSpan.className = 'wdg-filebird-explorer__content-table-icon wdg-filebird-explorer__content-table-icon--folder';
			anup_ffe_folderIconSpan.innerHTML = anup_ffe_iconSvgMarkupMap.folder;
			const anup_ffe_folderNameSpan = document.createElement( 'span' );
			anup_ffe_folderNameSpan.className = 'wdg-filebird-explorer__content-table-name';
			anup_ffe_folderNameSpan.textContent = folder.name || folder.text || '';
			anup_ffe_filenameCell.appendChild( anup_ffe_folderIconSpan );
			anup_ffe_filenameCell.appendChild( anup_ffe_folderNameSpan );
			anup_ffe_row.appendChild( anup_ffe_filenameCell );

			const anup_ffe_dateCell = document.createElement( 'td' );
			anup_ffe_dateCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--date';
			anup_ffe_dateCell.textContent = folder.modifiedFormatted || '—';
			anup_ffe_row.appendChild( anup_ffe_dateCell );

			const anup_ffe_typeCell = document.createElement( 'td' );
			anup_ffe_typeCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--type';
			anup_ffe_typeCell.textContent = anup_ffe_stringLabels.folderType || 'Folder';
			anup_ffe_row.appendChild( anup_ffe_typeCell );

			const anup_ffe_sizeCell = document.createElement( 'td' );
			anup_ffe_sizeCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--size';
			anup_ffe_sizeCell.textContent = folder.sizeFormatted || '—';
			anup_ffe_row.appendChild( anup_ffe_sizeCell );

			const anup_ffe_folderClickHandler = () => anup_ffe_loadFolder( state, Number( folder.id ) );
			anup_ffe_row.setAttribute( 'role', 'button' );
			anup_ffe_row.setAttribute( 'tabindex', '0' );
			anup_ffe_row.setAttribute( 'aria-label', folder.name || folder.text || '' );
			anup_ffe_row.addEventListener( 'click', anup_ffe_folderClickHandler );
			anup_ffe_attachKeyboardActivateHandler( anup_ffe_row, anup_ffe_folderClickHandler );

			anup_ffe_tbody.appendChild( anup_ffe_row );
		} );
	}

	anup_ffe_attachmentItems.forEach( ( attachment ) => {
		const anup_ffe_isImageAttachment = Boolean( attachment.isImage );
		const anup_ffe_attachmentMimeType = attachment.mimeType || '';
		const anup_ffe_isVideoAttachment = anup_ffe_attachmentMimeType.startsWith( 'video/' );
		const anup_ffe_mimeIconUrlValue = attachment.icon || '';

		const anup_ffe_row = document.createElement( 'tr' );
		anup_ffe_row.className = 'wdg-filebird-explorer__content-table-row wdg-filebird-explorer__content-table-row--file';

		const anup_ffe_filenameCell = document.createElement( 'td' );
		anup_ffe_filenameCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--filename';
		if ( anup_ffe_mimeIconUrlValue ) {
			const anup_ffe_iconImg = document.createElement( 'img' );
			anup_ffe_iconImg.className = 'wdg-filebird-explorer__content-table-icon wdg-filebird-explorer__content-table-icon--img';
			anup_ffe_iconImg.src = anup_ffe_mimeIconUrlValue;
			anup_ffe_iconImg.alt = '';
			anup_ffe_filenameCell.appendChild( anup_ffe_iconImg );
		} else {
			const anup_ffe_fileIconSpan = document.createElement( 'span' );
			anup_ffe_fileIconSpan.className = 'wdg-filebird-explorer__content-table-icon wdg-filebird-explorer__content-table-icon--file';
			anup_ffe_fileIconSpan.innerHTML = anup_ffe_isVideoAttachment ? anup_ffe_iconSvgMarkupMap.video : anup_ffe_iconSvgMarkupMap.file;
			anup_ffe_filenameCell.appendChild( anup_ffe_fileIconSpan );
		}
		const anup_ffe_fileNameSpan = document.createElement( 'span' );
		anup_ffe_fileNameSpan.className = 'wdg-filebird-explorer__content-table-name';
		anup_ffe_fileNameSpan.textContent = attachment.title || attachment.url;
		anup_ffe_filenameCell.appendChild( anup_ffe_fileNameSpan );
		anup_ffe_row.appendChild( anup_ffe_filenameCell );

		const anup_ffe_dateCell = document.createElement( 'td' );
		anup_ffe_dateCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--date';
		anup_ffe_dateCell.textContent = attachment.modifiedFormatted || '—';
		anup_ffe_row.appendChild( anup_ffe_dateCell );

		const anup_ffe_typeCell = document.createElement( 'td' );
		anup_ffe_typeCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--type';
		anup_ffe_typeCell.textContent = anup_ffe_formatFileTypeLabel( anup_ffe_attachmentMimeType, attachment.url );
		anup_ffe_row.appendChild( anup_ffe_typeCell );

		const anup_ffe_sizeCell = document.createElement( 'td' );
		anup_ffe_sizeCell.className = 'wdg-filebird-explorer__content-table-cell wdg-filebird-explorer__content-table-cell--size';
		anup_ffe_sizeCell.textContent = attachment.filesizeHumanReadable || '—';
		anup_ffe_row.appendChild( anup_ffe_sizeCell );

		const anup_ffe_mediaClickHandler = anup_ffe_createMediaClickHandler( attachment );
		anup_ffe_row.setAttribute( 'role', 'button' );
		anup_ffe_row.setAttribute( 'tabindex', '0' );
		anup_ffe_row.setAttribute( 'aria-label', attachment.title || attachment.url );
		anup_ffe_row.addEventListener( 'click', anup_ffe_mediaClickHandler );
		anup_ffe_attachKeyboardActivateHandler( anup_ffe_row, anup_ffe_mediaClickHandler );

		anup_ffe_tbody.appendChild( anup_ffe_row );
	} );

	const anup_ffe_displayedCount = anup_ffe_subfolderItems.length + anup_ffe_attachmentItems.length;
	const anup_ffe_totalInFolder = anup_ffe_subfolderItems.length + ( data.total != null ? Number( data.total ) : anup_ffe_attachmentItems.length );
	if ( ! append ) {
		state.totalFolderItems = anup_ffe_totalInFolder;
	}
	const anup_ffe_displayingTemplate = anup_ffe_stringLabels.displayingItems || 'Displaying %1 items out of %2';
	const anup_ffe_formatDisplaying = ( displayed, total ) =>
		anup_ffe_displayingTemplate.replace( '%1', displayed ).replace( '%2', total );

	if ( ! append && ( anup_ffe_subfolderItems.length || anup_ffe_attachmentItems.length ) ) {
		const anup_ffe_footer = document.createElement( 'div' );
		anup_ffe_footer.className = 'wdg-filebird-explorer__content-footer';
		anup_ffe_footer.textContent = anup_ffe_formatDisplaying( anup_ffe_displayedCount, state.totalFolderItems );
		anup_ffe_contentContainerElement.appendChild( anup_ffe_footer );
		state.contentFooter = anup_ffe_footer;
	} else if ( state.contentFooter && append ) {
		const anup_ffe_currentCount = anup_ffe_tbody.querySelectorAll( '.wdg-filebird-explorer__content-table-row' ).length;
		state.contentFooter.textContent = anup_ffe_formatDisplaying( anup_ffe_currentCount, state.totalFolderItems );
	}

	if ( ! anup_ffe_subfolderItems.length && ! anup_ffe_attachmentItems.length && ! append ) {
		const anup_ffe_emptyStateElement = document.createElement( 'div' );
		anup_ffe_emptyStateElement.className = 'wdg-filebird-explorer__empty';
		anup_ffe_emptyStateElement.textContent = anup_ffe_stringLabels.empty;
		anup_ffe_contentContainerElement.appendChild( anup_ffe_emptyStateElement );
	}

	anup_ffe_renderLoadMore( state, data.hasMore );
}

function anup_ffe_renderLoadMore( state, hasMore ) {
	const { content: anup_ffe_contentContainerElement } = state.shell;
	const { strings: anup_ffe_stringLabels } = state.config;

	if ( state.loadMoreButton ) {
		state.loadMoreButton.innerHTML = '';
		if ( ! hasMore ) {
			state.loadMoreButton.remove();
			state.loadMoreButton = null;
			return;
		}
		const anup_ffe_loadMoreButton = document.createElement( 'button' );
		anup_ffe_loadMoreButton.type = 'button';
		anup_ffe_loadMoreButton.textContent = anup_ffe_stringLabels.loadMore;
		anup_ffe_loadMoreButton.className = 'wdg-filebird-explorer__load-more-button';
		anup_ffe_loadMoreButton.addEventListener( 'click', () => {
			anup_ffe_loadFolder( state, state.activeFolder, state.page + 1, true );
		} );
		state.loadMoreButton.appendChild( anup_ffe_loadMoreButton );
		return;
	}

	if ( ! hasMore ) {
		return;
	}

	const anup_ffe_loadMoreWrapper = document.createElement( 'div' );
	anup_ffe_loadMoreWrapper.className = 'wdg-filebird-explorer__load-more';

	const anup_ffe_loadMoreButton = document.createElement( 'button' );
	anup_ffe_loadMoreButton.type = 'button';
	anup_ffe_loadMoreButton.textContent = anup_ffe_stringLabels.loadMore;
	anup_ffe_loadMoreButton.className = 'wdg-filebird-explorer__load-more-button';
	anup_ffe_loadMoreButton.addEventListener( 'click', () => {
		anup_ffe_loadFolder( state, state.activeFolder, state.page + 1, true );
	} );

	anup_ffe_loadMoreWrapper.appendChild( anup_ffe_loadMoreButton );
	anup_ffe_contentContainerElement.appendChild( anup_ffe_loadMoreWrapper );
	state.loadMoreButton = anup_ffe_loadMoreWrapper;
}

function anup_ffe_showLoading( state ) {
	state.shell.content.innerHTML = '';
	const anup_ffe_loadingMessageElement = document.createElement( 'div' );
	anup_ffe_loadingMessageElement.className = 'wdg-filebird-explorer__loading';
	anup_ffe_loadingMessageElement.textContent = state.config.strings.loading;
	state.shell.content.appendChild( anup_ffe_loadingMessageElement );
}

function anup_ffe_showError( state ) {
	state.shell.content.innerHTML = '';
	const anup_ffe_errorMessageElement = document.createElement( 'div' );
	anup_ffe_errorMessageElement.className = 'wdg-filebird-explorer__error';
	anup_ffe_errorMessageElement.textContent = state.config.strings.loadError;
	state.shell.content.appendChild( anup_ffe_errorMessageElement );
}

function anup_ffe_loadTree( state ) {
	const anup_ffe_requestParamsObject = {};
	const anup_ffe_rootFolderIdsList = anup_ffe_getRootFolders( state.config );
	if ( anup_ffe_rootFolderIdsList.length ) {
		anup_ffe_requestParamsObject.root = anup_ffe_rootFolderIdsList;
	}
	if ( state.searchValue ) {
		anup_ffe_requestParamsObject.search = state.searchValue;
	}

	// Show initial loading state in sidebar and content if tree is empty
	if ( ! state.treeData || state.treeData.length === 0 ) {
		const anup_ffe_treeLoadingWrap = document.createElement( 'div' );
		anup_ffe_treeLoadingWrap.className = 'wdg-filebird-explorer__tree-loading';
		const anup_ffe_treeLoadingParts = anup_ffe_createLoadingSpinnerAndText( state.config.strings.loading );
		anup_ffe_treeLoadingWrap.appendChild( anup_ffe_treeLoadingParts.spinner );
		anup_ffe_treeLoadingWrap.appendChild( anup_ffe_treeLoadingParts.textSpan );
		state.shell.tree.innerHTML = '';
		state.shell.tree.appendChild( anup_ffe_treeLoadingWrap );
		anup_ffe_showLoading( state );
	}

	state.treeRequestId += 1;
	const anup_ffe_requestSequenceId = state.treeRequestId;

	anup_ffe_fetchJson( state.config, 'tree', anup_ffe_requestParamsObject )
		.then( ( response ) => {
			if ( anup_ffe_requestSequenceId !== state.treeRequestId ) {
				return;
			}
			state.treeData = Array.isArray( response.tree ) ? response.tree : [];
			state.nodeMap = new Map();
			state.parentMap = new Map();
			anup_ffe_buildMaps( state.treeData, state.nodeMap, state.parentMap );

			const anup_ffe_selectedRootFolderIdsList = anup_ffe_getRootFolders( state.config );
			const anup_ffe_limitTreeToRoots = Boolean( state.searchValue );
			const anup_ffe_topLevelRootFolderIdsList = anup_ffe_limitTreeToRoots
				? anup_ffe_selectedRootFolderIdsList
				: anup_ffe_filterRootIdsToTopLevel( anup_ffe_selectedRootFolderIdsList, state.parentMap );
			const anup_ffe_treeRootDisplayNodes = anup_ffe_selectedRootFolderIdsList.length
				? ( anup_ffe_limitTreeToRoots
					? state.treeData
					: anup_ffe_topLevelRootFolderIdsList.map( ( rootId ) => state.nodeMap.get( rootId ) ).filter( Boolean ) )
				: state.treeData.filter( ( node ) => ! node.parent || Number( node.parent ) === 0 );
			const anup_ffe_firstRootFolderId = anup_ffe_treeRootDisplayNodes.length ? Number( anup_ffe_treeRootDisplayNodes[ 0 ].id ) : 0;
			const anup_ffe_rootNodeIdsForExpansionList = anup_ffe_treeRootDisplayNodes
				.map( ( node ) => Number( node.id ) )
				.filter( ( nodeId ) => nodeId > 0 );

			const anup_ffe_urlFolderId = anup_ffe_getFolderIdFromUrl();
			const anup_ffe_sessionFolderId = anup_ffe_restoreActiveFolder( state.config );
			const anup_ffe_restoreId = anup_ffe_urlFolderId !== null
				? anup_ffe_urlFolderId
				: anup_ffe_sessionFolderId;
			// When folder is not from URL (restored from session), remove param from URL on next loadFolder
			state.skipNextUrlUpdate = anup_ffe_urlFolderId === null && anup_ffe_sessionFolderId !== null;

			if ( anup_ffe_restoreId !== null ) {
				if ( anup_ffe_restoreId === 0 ) {
					state.activeFolder = anup_ffe_firstRootFolderId;
					state.expanded = new Set( anup_ffe_rootNodeIdsForExpansionList );
				} else if ( state.nodeMap.has( anup_ffe_restoreId ) ) {
					state.activeFolder = anup_ffe_restoreId;
					const anup_ffe_ancestorIds = anup_ffe_getAncestorIds( anup_ffe_restoreId, state.parentMap );
					state.expanded = new Set( [ ...anup_ffe_rootNodeIdsForExpansionList, ...anup_ffe_ancestorIds ] );
				} else {
					state.activeFolder = anup_ffe_firstRootFolderId;
					state.expanded = new Set( anup_ffe_rootNodeIdsForExpansionList );
				}
			} else {
				if ( ! state.activeFolder || ! state.nodeMap.has( Number( state.activeFolder ) ) ) {
					state.activeFolder = anup_ffe_firstRootFolderId;
				}
				state.expanded = new Set( anup_ffe_rootNodeIdsForExpansionList );
			}

			anup_ffe_renderTree( state );
			anup_ffe_loadFolder( state, state.activeFolder );
		} )
		.catch( () => {
			anup_ffe_showError( state );
		} );
}

function anup_ffe_loadFolder( state, folderId, page = 1, append = false ) {
	state.activeFolder = folderId;
	state.page = page;
	if ( ! append ) {
		anup_ffe_saveActiveFolder( state.config, folderId );
		if ( state.skipNextUrlUpdate ) {
			state.skipNextUrlUpdate = false;
			anup_ffe_setFolderIdInUrl( 0 );
		} else {
			anup_ffe_setFolderIdInUrl( folderId );
		}
		if ( folderId > 0 && state.parentMap && state.parentMap.size > 0 ) {
			const anup_ffe_ancestorIds = anup_ffe_getAncestorIds( folderId, state.parentMap );
			anup_ffe_ancestorIds.forEach( ( id ) => state.expanded.add( id ) );
		}
	}
	if ( state.loadMoreButton ) {
		if ( append ) {
			const anup_ffe_btn = state.loadMoreButton.querySelector( '.wdg-filebird-explorer__load-more-button' );
			if ( anup_ffe_btn ) {
				anup_ffe_btn.remove();
			}
			const anup_ffe_loadingEl = document.createElement( 'div' );
			anup_ffe_loadingEl.className = 'wdg-filebird-explorer__load-more-loading wdg-filebird-explorer__loading';
			anup_ffe_loadingEl.setAttribute( 'aria-busy', 'true' );
			const anup_ffe_loadMoreLoadingParts = anup_ffe_createLoadingSpinnerAndText( state.config.strings.loading );
			anup_ffe_loadingEl.appendChild( anup_ffe_loadMoreLoadingParts.spinner );
			anup_ffe_loadingEl.appendChild( anup_ffe_loadMoreLoadingParts.textSpan );
			state.loadMoreButton.appendChild( anup_ffe_loadingEl );
		} else {
			state.loadMoreButton.remove();
			state.loadMoreButton = null;
		}
	}
	state.attachmentsWrapper = append ? state.attachmentsWrapper : null;

	if ( ! append ) {
		anup_ffe_showLoading( state );
		anup_ffe_renderBreadcrumb( state );
		anup_ffe_renderTree( state );
	}

	const anup_ffe_requestParamsObject = {
		page,
		perPage: state.config.perPage,
	};
	const anup_ffe_rootFolderIdsList = anup_ffe_getRootFolders( state.config );
	if ( anup_ffe_rootFolderIdsList.length ) {
		anup_ffe_requestParamsObject.root = anup_ffe_rootFolderIdsList;
	}

	state.folderRequestId += 1;
	const anup_ffe_requestSequenceId = state.folderRequestId;

	anup_ffe_fetchJson( state.config, `folder/${folderId}`, anup_ffe_requestParamsObject )
		.then( ( data ) => {
			if ( anup_ffe_requestSequenceId !== state.folderRequestId ) {
				return;
			}
			anup_ffe_renderContent( state, data, append );
		} )
		.catch( () => {
			anup_ffe_showError( state );
		} );
}

export function anup_ffe_initExplorer( root, overrides = {} ) {
	if ( ! root ) {
		return;
	}

	const anup_ffe_blockConfigObject = anup_ffe_parseConfig( root, overrides );
	const anup_ffe_shellElementsGroup = anup_ffe_ensureShell( root );

	const anup_ffe_previousStateEntry = anup_ffe_stateByRoot.get( root );
	const anup_ffe_blockStateObject = anup_ffe_previousStateEntry || {
		config: anup_ffe_blockConfigObject,
		shell: anup_ffe_shellElementsGroup,
		treeData: [],
		nodeMap: new Map(),
		parentMap: new Map(),
		expanded: new Set(),
		activeFolder: 0,
		page: 1,
		attachmentsWrapper: null,
		loadMoreButton: null,
		searchValue: '',
		searchTimer: null,
		searchHandler: null,
		modal: null,
		skipNextUrlUpdate: false,
		treeRequestId: 0,
		folderRequestId: 0,
	};

	anup_ffe_blockStateObject.config = anup_ffe_blockConfigObject;
	anup_ffe_blockStateObject.shell = anup_ffe_shellElementsGroup;
	anup_ffe_stateByRoot.set( root, anup_ffe_blockStateObject );

	if ( ! anup_ffe_blockConfigObject.restBase ) {
		anup_ffe_showError( anup_ffe_blockStateObject );
		return;
	}

	// Create modal at init so it lives on the shell and is never cleared when content is replaced
	anup_ffe_ensureModal( anup_ffe_blockStateObject );

	anup_ffe_setupResize( root );

	anup_ffe_blockStateObject.shell.searchInput.placeholder = anup_ffe_blockConfigObject.strings.searchPlaceholder;
	if ( anup_ffe_blockStateObject.searchHandler ) {
		anup_ffe_blockStateObject.shell.searchInput.removeEventListener( 'input', anup_ffe_blockStateObject.searchHandler );
	}
	anup_ffe_blockStateObject.searchHandler = ( event ) => {
		const anup_ffe_searchInputValue = event.target.value.trim();
		anup_ffe_blockStateObject.searchValue = anup_ffe_searchInputValue;
		if ( anup_ffe_blockStateObject.searchTimer ) {
			clearTimeout( anup_ffe_blockStateObject.searchTimer );
		}
		anup_ffe_blockStateObject.searchTimer = setTimeout( () => {
			anup_ffe_loadTree( anup_ffe_blockStateObject );
		}, 300 );
	};
	anup_ffe_blockStateObject.shell.searchInput.addEventListener( 'input', anup_ffe_blockStateObject.searchHandler );
	anup_ffe_blockStateObject.shell.searchInput.value = anup_ffe_blockStateObject.searchValue || '';

	// Refresh the nonce before the first request so a bfcache-restored shell with a
	// stale baked nonce still authenticates without a manual reload.
	anup_ffe_refreshNonce( anup_ffe_blockStateObject.config ).then( () => {
		anup_ffe_loadTree( anup_ffe_blockStateObject );
	} );
}

export function anup_ffe_bootExplorer() {
	document.querySelectorAll( '.wdg-filebird-explorer' ).forEach( ( element ) => {
		anup_ffe_initExplorer( element );
	} );
}

anup_ffe_bootExplorer();

// When the page is restored from the browser bfcache (e.g. logging in and using the
// back button to return here), scripts do not re-run — re-boot so the explorer picks
// up the current session instead of showing the stale locked state.
window.addEventListener( 'pageshow', ( event ) => {
	if ( event.persisted ) {
		anup_ffe_bootExplorer();
	}
} );
